// Laboratory documentation: https://product.hubteam.com/docs/laboratory/guides/coding-a-frontend-experiment.html

import { createClient } from 'laboratory-lib';
import portalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
import experiments from '../../experiments.yaml';
import { getDeviceId, getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { isIndexedDBSupported } from './isIndexedDBSupported';
const identifiers = {
  portalId: portalIdParser.get(),
  other: getDeviceId(),
  utk: getUtk()
};

// When IndexedDB is unavailable (headless crawlers), passing `store: null` makes
// laboratory-lib use an in-memory mock store instead of the default IndexedDB
// SuperStore, which would otherwise reject with an unhandled
// "IndexedDB is not supported in this environment." error.
const store = isIndexedDBSupported() ? undefined : null;
function buildLaboratoryClient() {
  try {
    return createClient({
      name: 'pricing-pages-client',
      quickFetchLabel: 'experiment-treatments',
      identifiers,
      experiments: experiments,
      store
    });
  } catch (quickFetchError) {
    Raven.captureException(quickFetchError, {
      level: 'warning'
    });
    try {
      return createClient({
        name: 'pricing-pages-client',
        identifiers,
        experiments: experiments,
        store
      });
    } catch (fallbackError) {
      Raven.captureException(fallbackError);
      throw fallbackError;
    }
  }
}
export const laboratoryClient = buildLaboratoryClient();
export const logExposure = treatmentKey => laboratoryClient.logExposure(treatmentKey);